// This file maps universal lab keys to their user-friendly display names.
// This ensures consistency between PDF import and manual lab entry
// Updated to include ALL parameters from parameters.md for complete standardization

export const labKeyToDisplayNameMap = {
  // === CARDIAC ===
  'labs_cardiac_troponin': 'Troponin-HS',
  'labs_cardiac_bnp': 'BNP',
  'labs_cardiac_ckmb': 'CK-MB',
  
  // === CBC ===
  'labs_cbc_wbc': 'WBC',
  'labs_cbc_neut': 'Neutrophil',
  'labs_cbc_lymph': 'Lymphocyte',
  'labs_cbc_mono': 'Monocyte',
  'labs_cbc_eos': 'Eosinophil',
  'labs_cbc_baso': 'Basophil',
  'labs_cbc_neut_pct': 'Neutrophil %',
  'labs_cbc_lymph_pct': 'Lymphocyte %',
  'labs_cbc_mono_pct': 'Monocyte %',
  'labs_cbc_eos_pct': 'Eosinophil %',
  'labs_cbc_baso_pct': 'Basophil %',
  'labs_cbc_rbc': 'RBC',
  'labs_cbc_hgb': 'HGB',
  'labs_cbc_hct': 'HCT',
  'labs_cbc_mcv': 'MCV',
  'labs_cbc_mch': 'MCH',
  'labs_cbc_mchc': 'MCHC',
  'labs_cbc_rdw': 'RDW',
  'labs_cbc_rdw_sd': 'RDW-SD',
  'labs_cbc_plt': 'PLT',
  'labs_cbc_mpv': 'MPV',
  'labs_cbc_pdw': 'PDW',
  'labs_cbc_pct': 'PCT',
  'labs_cbc_p_lcr': 'P-LCR',
  'labs_cbc_nlr': 'NLR',
  
  // === COAGULATION ===
  'labs_coagulation_pt': 'PT',
  'labs_coagulation_inr': 'INR',
  'labs_coagulation_ptt': 'PTT',
  'labs_coagulation_thrombin_time': 'Thrombin Time',
  'labs_coagulation_fibrinogen': 'Fibrinogen',
  'labs_coagulation_d_dimer': 'D-dimer',
  
  // === GLUCOSE ===
  'labs_glucose_hba1c': 'HbA1c',
  'labs_glucose_glucose': 'Glucose (Serum)',
  
  // === LIPID ===
  'labs_lipid_apob': 'Apo B',
  'labs_lipid_chol_total': 'Cholesterol Total',
  'labs_lipid_hdl': 'HDL',
  'labs_lipid_ldl': 'LDL',
  'labs_lipid_trig': 'Triglyceride',
  'labs_lipid_vldl': 'VLDL',
  'labs_lipid_non_hdl': 'non-HDL Cholesterol',
  'labs_lipid_tg_hdl_ratio': 'TG/HDL Ratio',
  'labs_lipid_tc_glu_ratio': 'TC/GLU Ratio',
  'labs_lipid_tc_hdl_ratio': 'TC/HDL Ratio',
  'labs_lipid_athero_idx': 'Atherogenic Index',
  
  // === ELECTROLYTES ===
  'labs_electrolytes_magnesium': 'Magnesium',
  'labs_electrolytes_phosphorous': 'Phosphorous',
  'labs_electrolytes_sodium': 'Sodium',
  'labs_electrolytes_potassium': 'Potassium',
  'labs_electrolytes_chloride': 'Chloride',
  'labs_electrolytes_calcium': 'Calcium, Ionized',
  'labs_electrolytes_bicarb': 'Bicarbonate-CO2',
  'labs_electrolytes_osmolality': 'Osmolality',
  'labs_electrolytes_na_k_ratio': 'Sodium/Potassium Ratio',
  
  // === VITAMINS ===
  'labs_vitamins_iron': 'Iron',
  'labs_vitamins_b12': 'Vitamin B12',
  'labs_vitamins_d3': 'Vitamin D, 25-Hydroxy',
  'labs_vitamins_b9': 'Folate',
  'labs_vitamins_ferritin': 'Ferritin',
  
  // === RENAL ===
  'labs_renal_creatinine': 'Creatinine',
  'labs_renal_egfr': 'eGFR',
  'labs_renal_urea': 'Urea',
  'labs_renal_bun': 'BUN',
  'labs_renal_bun_creat_ratio': 'BUN/Creatinine Ratio',
  
  // === INFLAMMATION ===
  'labs_inflammation_uric_acid': 'Uric Acid',
  'labs_inflammation_hscrp': 'hsCRP',
  'labs_inflammation_esr': 'ESR',
  
  // === HEPATOLOGY ===
  'labs_hepatology_ast': 'AST',
  'labs_hepatology_alt': 'ALT',
  'labs_hepatology_ggt': 'GGT',
  'labs_hepatology_bili_total': 'Bilirubin, Total',
  'labs_hepatology_bili_direct': 'Bilirubin, Direct',
  'labs_hepatology_bili_indirect': 'Bilirubin Indirect',
  'labs_hepatology_alp': 'Alkaline Phosphatase',
  
  // === PROTEIN ===
  'labs_protein_total': 'Total Protein',
  'labs_protein_albumin': 'Albumin',
  'labs_protein_prealbumin': 'Prealbumin',
  'labs_protein_alb_glob_ratio': 'Albumin/Globulin Ratio',
  
  // === THYROID ===
  'labs_thyroid_ft4': 'Free T4',
  'labs_thyroid_tsh': 'TSH',
  'labs_thyroid_ft3': 'Free T3',
  
  // === URINE ===
  'labs_urine_sg': 'Specific Gravity',
  'labs_urine_ph': 'pH',
  'labs_urine_nitrite': 'Nitrite',
  'labs_urine_protein': 'Protein',
  'labs_urine_glucose': 'Glucose (Urine)',
  'labs_urine_ketones': 'Ketones',
  'labs_urine_urobil': 'Urobilinogen',
  'labs_urine_bili': 'Bilirubin',
  'labs_urine_ery': 'Erythrocyte',
  'labs_urine_leuk': 'Leukocyte',
  'labs_urine_microalb': 'Microalbumin',
  'labs_urine_creat': 'Creatinine (Urine)',
  'labs_urine_uacr': 'UACR'
};
